// extracted by mini-css-extract-plugin
module.exports = {"outer":"FlexHero_outer__kOrPA","hero-image":"FlexHero_hero-image__wybnK"};